import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  seoMarketingIcon,
  socialMarketingIcon,
  emailMarketinIcon,
  influencerMarketingIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";
import PayPerClickWork from "./PayPerClickWork";
import { useEffect } from "react";

const items = [
  {
    name: "Google Ads Campaigns",
    text: "Be there when your customer is actively looking. Google Ads puts you in front of the right people at the right time, whether they’re searching, browsing, or watching on YouTube.",
  },
  {
    name: "Meta Ads (Facebook & Instagram)",
    text: "Your audience is already scrolling, let’s meet them there. With targeted Meta ads and thumb-stopping creatives, your brand gets seen, clicked, and remembered.",
  },
  {
    name: "Conversion Tracking & Optimisation",
    text: "Getting clicks is easy. Turning them into customers? That’s the real win. We track what’s working, fix what’s not, and keep improving to get you better results every time.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const PayPerClick = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "PPC Management Services | Google & Meta Ads | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "ROI-focused PPC management services for Google and Meta Ads. TechQilla drives high-quality leads with optimized ad strategies.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "PPC Management Services");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/pay-per-click",
    );
  }, []);

  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Click"
        description="You’ve got a great product. We make sure the right people see it through focused PPC campaigns that get clicks, drive leads and help you grow without wasting money."
        heading="Pay Per"
      />
      <NewCommonServiceForm title="Pay Per CLick" items={items} />
      <PayPerClickWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PayPerClick;
